<template>
  <div>
    <div id="specialsSliderVLuxury" class="carousel slide" data-ride="carousel" :data-brand="getBrand">
      <div class="carousel-inner" role="listbox">
        
        <!-- Slide -->
        <div class="item active">
          <div class="slide-content">
            <div class="slide-content__img" :style="{backgroundImage: bgImage1}"></div>
            <div class="slide-content__offer">
              <a href="#slider-disclaimers" class="slide-offer__disclaimer" data-toggle="modal" data-target="#slider6040DisclaimerModal" data-has-disclaimer="true">
                <p>Terms & Conditions</p>
              </a>
              <div class="hidden disclaimer-content">*36-months 2.9% APR - Offers for well-qualified buyers with approved credit. Applies only to dealer in-stock units. May not be combined with certain other offers. Excludes tax, tags, registration fee, title and $699 dealer administrative charge. See dealer for details.</div>
              <h3 class="slide-offer__title less-emphasis">New {{getBrandForSlideContent}}Models</h3>
              <p class="slide-offer__txt more-emphasis">2.9% APR</p>
              <p class="slide-offer__txt less-emphasis">Available for up to 36 months</p>
              <a class="sokal-link sokal-link-secondary dark-theme" href="#">
                <div class="sokal-flex sokal-flex-row sokal-gap sokal-items-center sokal-justify-center">
                  <span class="sokal-link-copy">Shop Now</span>
                  <svg xmlns="http://www.w3.org/2000/svg" width="1.13em" height="1.6em" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-arrow-right">
                    <line x1="5" y1="12" x2="19" y2="12"></line>
                    <polyline points="12 5 19 12 12 19"></polyline>
                  </svg>
                </div>
              </a>
            </div>
          </div>
        </div>
        <!-- Slide -->
        <div class="item">
          <div class="slide-content">
            <div class="slide-content__img" :style="{backgroundImage: bgImage2}"></div>
            <div class="slide-content__offer">
              <h3 class="slide-offer__title weight-light">Time for an oil change?</h3>
              <p class="slide-offer__txt">Schedule an appointment with us today.</p>
              <a class="sokal-link sokal-link-secondary dark-theme" href="#">
                <div class="sokal-flex sokal-flex-row sokal-gap sokal-items-center sokal-justify-center">
                  <span class="sokal-link-copy">Schedule Now</span>
                  <svg xmlns="http://www.w3.org/2000/svg" width="1.13em" height="1.6em" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-arrow-right">
                    <line x1="5" y1="12" x2="19" y2="12"></line>
                    <polyline points="12 5 19 12 12 19"></polyline>
                  </svg>
                </div>
              </a>
              <a href="#slider-disclaimers" class="slide-offer__disclaimer" data-toggle="modal" data-target="#slider6040DisclaimerModal" data-has-disclaimer="false">
                <p>Terms & Conditions</p>
              </a>
              <div class="hidden disclaimer-content">Disclaimer...</div>
            </div>
          </div>
        </div>

      </div>
      <ol class="carousel-indicators">
        <li class="sokal-slide-indicator active" data-slide-to="0" data-target="#specialsSliderVLuxury"></li>
        <li class="sokal-slide-indicator" data-slide-to="1" data-target="#specialsSliderVLuxury"></li>
      </ol>
      <!-- <a class="left carousel-control" href="#specialsSliderVLuxury" role="button" data-slide="prev">
        <span class="glyphicon glyphicon-chevron-left" aria-hidden="true"></span>
        <span class="sr-only">Previous</span>
      </a>
      <a class="right carousel-control" href="#specialsSliderVLuxury" role="button" data-slide="next">
        <span class="glyphicon glyphicon-chevron-right" aria-hidden="true"></span>
        <span class="sr-only">Next</span>
      </a> -->
    </div>

    <div class="modal fade" id="slider6040DisclaimerModal" tabindex="-1" role="dialog" aria-labelledby="slider6040DisclaimerModalLabel">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
          </div>
          <div class="modal-body">
            <!-- Dynamically Populate content here -->
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
  export default {
    props: ['images'],
    data() {
      return {
        brand: this.$store.state.chosenBrand
      }
    },
    computed: {
      getBrand () {
        if (this.brand.toLowerCase() === 'none') {
          return 'Default';
        } else {
          return this.brand.substr(0,1).toUpperCase() + this.brand.substr(1);
        }
      }, 

      getBrandForSlideContent () {
        return this.formatBrandForSlideContent();
      }, 

      bgImage1 () {
        return 'url(' + this.images.lifestyleImages.sedanImage + ')';
      }, 

      bgImage2 () {
        return 'url(' + this.images.lifestyleImages.defaultImage + ')';
      }
    }, 

    mounted () {
      this.init();
      this.initSwipe();
    }, 

    methods: {
      init () {
        this.populateDisclaimerModal();
        const $carousel = $('#specialsSliderVLuxury');

        $carousel.carousel({
          interval: 5000
        });
        $carousel.on('slid.bs.carousel', () => {
          this.onCarouselSlide();
        });
      },
      
      initSwipe() {
        const $ = window.jQuery
        if (!$ || !$.fn.swipe) return

        const $carousel = $('#specialsSliderVLuxury')
        if (!$carousel.length) return

        $carousel.swipe({
          swipeLeft() {
            $(this).carousel('next')
          },
          swipeRight() {
            $(this).carousel('prev')
          },
          threshold: 50
        })
      },

      onCarouselSlide () {
        const $activeItem = $('#specialsSliderVLuxury .item.active');

        // Example: add active class somewhere else
        $('.some-linked-element').removeClass('active');
        $activeItem.find('.some-linked-element').addClass('active');
      },

      returnBrand () {
        if (this.brand.toLowerCase() === 'none') {
          return 'Default';
        } else {
          return this.brand.substr(0,1).toUpperCase() + this.brand.substr(1);
        }
      }, 

      formatBrandForSlideContent () {
        const brand = this.returnBrand();
        if (brand === 'Default') {
          return ' ';
        } else {
          return ' ' + brand + ' ';
        }
      }, 

      populateDisclaimerModal () {
        $('#specialsSliderVLuxury .slide-offer__disclaimer').click(function(){
          const disclaimerContent = $(this).parent().find('.disclaimer-content').html();
          $('#slider6040DisclaimerModal .modal-body').empty().append(disclaimerContent);
        })
      }
    }
  };
</script>

<style
  scoped
  src="../../static/bootstrap-3.3.7-dist/css/bootstrap.min.css"
></style>

<style lang="scss" scoped>
  @import '@/assets/styles/sokal-utility-classes.scss';
  @import '@/assets/styles/sokal-modern-styles.scss';
  @import '@/assets/styles/modern-utility-classes.scss';
  @import '@/assets/styles/sokal_utility_classes_responsive.scss';
</style>

<style scoped>

  #preview:has(#specialsSliderVLuxury) {
      margin-left: -9px;
      margin-right: -9px;
  }

  /* Brand-Specific Utility Styles */

  #specialsSliderVLuxury[data-brand="Ford"] {
    --primary-dark: var(--secondary-color);
  }
  
  #specialsSliderVLuxury[data-brand="Toyota"] .btn-branded {
    border-radius: 50px;
    padding: 10px 20px 12px 20px;
  }

  #specialsSliderVLuxury[data-brand="Infiniti"] .slide-content__offer {
    background-color: var(--primary-color, #020B24);
  }
  #specialsSliderVLuxury[data-brand="Infiniti"] .slide-offer__title,
  #specialsSliderVLuxury[data-brand="Infiniti"] .slide-offer__txt,
  #specialsSliderVLuxury[data-brand="Infiniti"] .btn-branded,
  #specialsSliderVLuxury[data-brand="Infiniti"] .slide-offer__disclaimer {
    font-family: Infiniti-Light, 'Infiniti-Light', Arial, sans-serif;
  }
  #specialsSliderVLuxury[data-brand="Infiniti"] .btn-branded {
    border-radius: 50px;
    border: 3px solid var(--primary-light, #ffffff)
  }
  
  /* 6040 Slider Styles */

  #specialsSliderVLuxury .carousel-inner .item {
    width: 100%;
  }
  #specialsSliderVLuxury .slide-content {
    display: flex;
    flex-direction: row-reverse;
    align-items: center;
    justify-content: center;
    margin: 15px;
    column-gap: 15px;
    width: calc(100% - 30px);
    min-height: 300px;
    height: 45vh;
    max-height: 450px;
  }
  #specialsSliderVLuxury .slide-content > * {
    height: 100%;
  }
  #specialsSliderVLuxury .slide-content__img {
    width: 70%;
    border-radius: 10px;
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
  }
  #specialsSliderVLuxury .slide-content__offer {
    width: 30%;
    height: 100%;
    border-radius: 10px;
    display: inline-flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    background-color: var(--primary-dark);
    color: #ffffff;
    padding: 20px;
    row-gap: 5px;
  }
  .slide-offer__title {
    margin: auto 0 15px 0;
    text-shadow: 0 0 #ffffff;
    font-size: 28px;
    font-weight: 400;
  }
  .slide-offer__txt {
    font-size: 14px;
  }
  .slide-offer__btn {
    margin: 20px 0 40px 0;
  }
  .slide-offer__disclaimer {
    text-decoration: none;
    font-size: 10px;
    color: #ffffff;
    border-bottom: solid 1px #ffffff;
    padding-bottom: 2px;
    opacity: 0.7;
    -webkit-transition: all 0.3s ease;
    -moz-transition: all 0.3s ease;
    transition: all 0.3s ease;
    margin-left: auto;
  }
  .slide-offer__disclaimer:hover, 
  .slide-offer__disclaimer:active, 
  .slide-offer__disclaimer:focus {
    text-decoration: none;
    color: #ffffff;
    opacity: 1;
  }
  #specialsSliderVLuxury .slide-offer__disclaimer {
    display: none;
  }
  
  #specialsSliderVLuxury .slide-offer__disclaimer[data-has-disclaimer="true"], 
  #specialsSliderVLuxury .slide-offer__disclaimer[data-has-disclaimer="True"] {
    display: block;
  }
  .slide-offer__disclaimer p {
    margin-bottom: 0;
  }

  .carousel-indicators {
    left: 0;
    padding-left: 30px;
    margin-left: 0;
    width: fit-content;
  }
  .carousel-indicators li {
    width: 10px;
    background-color: rgba(255, 255, 255, 0.25);
    border: none;
    margin: 0 0 0 5px;
  }

  .carousel-indicators li.active {
    height: 10px;
    width: 30px;
    background-color: #ffffff;
    margin: 0 0 0 5px;
  }

  .carousel-indicators li[data-slide-to="0"] {
    margin: 0 0 0 10px;
  }

  .carousel-indicators.cap-width li[data-slide-to="0"] {
    margin-left: 5px;
  }

  #specialsSliderVLuxury .sokal-link-secondary {
    color: #ffffff;
    font-size: 1.75rem;
    font-weight: 600;
    margin: auto 0 -7.5px auto;
  }

  #specialsSliderVLuxury .sokal-link-secondary .sokal-gap {
    --sokal-gap-value: 10px;
  }

  #specialsSliderVLuxury .less-emphasis {
    font-size: 1.5rem;
    font-weight: 600;
    margin-bottom: 0;
  }

  #specialsSliderVLuxury .more-emphasis {
    font-size: 4rem;
    font-weight: 600;
  }



  #specialsSliderVLuxury .carousel-control {
    opacity: 0.7;
    width: 7.5%;
  }
  #specialsSliderVLuxury .carousel-control:hover, 
  #specialsSliderVLuxury .carousel-control:active, 
  #specialsSliderVLuxury .carousel-control:focus {
    opacity: 1;
  }
  #specialsSliderVLuxury .carousel-control .glyphicon-chevron-left {
    transform: translateX(-25%);
  }
  #specialsSliderVLuxury .carousel-control .glyphicon-chevron-right {
    transform: translateX(25%);
  }

  #specialsSliderVLuxury .carousel-control .glyphicon::before {
    content: '';
  }
  #specialsSliderVLuxury .carousel-control .glyphicon {
    background-image: url(https://d2v1gjawtegg5z.cloudfront.net/uploads/files/000/309/655/original/toyota-arrow-right-white.png?1669999978);
    background-position: center;
    background-size: 30%;
    background-repeat: no-repeat;
    border: solid 2px #ffffff;
    border-radius: 100%;
    width: 40px;
    height: 40px;
  }
  #specialsSliderVLuxury .carousel-control .glyphicon-chevron-left {
    transform: translateX(-25%) rotate(180deg);
  }

  @media (min-height: 789px) {
    #specialsSliderVLuxury .slide-content {
      height: 50vh;
    }
  }

  @media (min-width: 768px) and (max-width: 1199px) {
    #specialsSliderVLuxury .slide-content__img {
      width: 60%;
    }
    #specialsSliderVLuxury .slide-content__offer {
      width: 40%;
    }
    .carousel-indicators.cap-width {
      max-width: 25%;
      text-align: left;
    }
    #specialsSliderVLuxury .less-emphasis {
      font-size: 1.25rem;
    }
    #specialsSliderVLuxury .more-emphasis {
      font-size: 3rem;
    }
    #specialsSliderVLuxury .sokal-link-secondary {
      margin: auto auto auto 0;
      font-size: 1.5rem;
    }
  }

  @media (min-width: 1200px) and (max-width: 1400px) {
    #specialsSliderVLuxury .sokal-link-secondary.stack-btn {
      margin: auto auto auto 0;
    }
  }

  @media (max-width: 767px) {
    #specialsSliderVLuxury .slide-content {
      flex-direction: column-reverse;
      min-height: 500px;
      height: 64vh;
      row-gap: 10px;
    }

    #specialsSliderVLuxury .slide-content__img {
      width: 100%;
      height: 40%;
    }

    #specialsSliderVLuxury .slide-content__offer {
      width: 100%;
      height: 60%;
      row-gap: 0;
    }

    .slide-offer__title {
      font-size: 20px;
      margin-bottom: 10px;
    }

    .slide-offer__txt,
    #specialsSliderVLuxury .less-emphasis {
      font-size: 1rem;
    }

    #specialsSliderVLuxury .more-emphasis {
      font-size: 2.5rem;
    }

    .slide-offer__btn {
      margin: 10px 0 20px 0;
    }

    #specialsSliderVLuxury .carousel-indicators {
      bottom: 43%;
      padding-left: 25px;
      margin-bottom: 0;
    }

    #specialsSliderVLuxury .sokal-link-secondary {
      margin: auto 0;
    }

  }

  /* Brand-Specific Component Styles */
  #specialsSliderVLuxury:not([data-brand="Toyota"]) .carousel-control .glyphicon {
    border: none;
  }

</style>